module.exports = __webpack_public_path__ + "img/balkongelaender_2.1fc9e983.webp";